const ROUTE_TITLE_RULES: ReadonlyArray<readonly [RegExp, string]> = [
  [/^\/$/, 'home'],
  [/^\/auth\/login$/, 'login'],
  [/^\/auth\/forgot-password$/, 'forgot_password'],
  [/^\/auth\/reset-password$/, 'reset_password'],
  [/^\/auth\/signup$/, 'signup'],
  [/^\/auth\/accept-invitation$/, 'accept_invitation'],
  [/^\/auth\/register\/confirm$/, 'register_confirm'],
  [/^\/auth\/magic-link$/, 'magic_link'],
  [/^\/reservation\/properties\/[^/]+\/booking$/, 'property_booking'],
  [/^\/reservation\/properties\/[^/]+\/waiting-queue$/, 'waiting_queue'],
  [/^\/reservation\/properties\/[^/]+$/, 'property_detail'],
  [/^\/reservation(\/properties)?$/, 'properties'],
  [/^\/reservation\/request\/[^/]+$/, 'reservation_request'],
  [/^\/reservation\/high-season(\/|$)/, 'high_season'],
  [/^\/reservation\/confirmation\/[^/]+$/, 'reservation_confirmation'],
  [/^\/ticketing$/, 'ticketing'],
  [/^\/ticketing\//, 'ticketing_offer'],
  [/^\/listings$/, 'listings'],
  [/^\/listings\/mine$/, 'listings_mine'],
  [/^\/listings\/[^/]+\/edit$/, 'listing_edit'],
  [/^\/listings\/[^/]+$/, 'listing_detail'],
  [/^\/group-trips$/, 'group_trips'],
  [/^\/group-trips\/[^/]+$/, 'group_trip_detail'],
  [/^\/colony$/, 'colony'],
  [/^\/colony\/sessions\/[^/]+$/, 'colony_session'],
  [/^\/match-event$/, 'match_event'],
  [/^\/match-event\/clubs$/, 'match_clubs'],
  [/^\/match-event\/[^/]+$/, 'match_detail'],
  [/^\/partner-offers$/, 'partner_offers'],
  [/^\/partner-offers\/redeem\/[^/]+$/, 'partner_offer_redeem'],
  [/^\/partner-offers\/[^/]+$/, 'partner_offer_detail'],
  [/^\/blog$/, 'blog'],
  [/^\/blog\/[^/]+$/, 'blog_article'],
  [/^\/faq$/, 'faq'],
  [/^\/onboarding$/, 'onboarding'],
  [/^\/lottery$/, 'lottery'],
  [/^\/lottery\/tombola$/, 'tombola'],
  [/^\/lottery\/draws\/[^/]+$/, 'lottery_draw'],
  [/^\/me$/, 'me'],
  [/^\/me\/reservations$/, 'me_reservations'],
  [/^\/me\/reservations\/[^/]+$/, 'me_reservation_detail'],
  [/^\/me\/group-trips$/, 'me_group_trips'],
  [/^\/me\/colony-registrations$/, 'me_colony_registrations'],
  [/^\/me\/partner-offers$/, 'me_partner_offers'],
  [/^\/me\/favorites$/, 'me_favorites'],
  [/^\/me\/invoices$/, 'me_invoices'],
  [/^\/me\/invoices\/[^/]+$/, 'me_invoice_detail'],
  [/^\/me\/tickets$/, 'me_tickets'],
  [/^\/me\/tickets\/[^/]+$/, 'me_ticket_detail'],
  [/^\/me\/match-tickets$/, 'me_match_tickets'],
  [/^\/me\/match-tickets\/[^/]+$/, 'me_match_ticket_detail'],
  [/^\/me\/sessions$/, 'me_sessions'],
  [/^\/me\/gdpr$/, 'me_gdpr'],
  [/^\/me\/beneficiaries$/, 'me_beneficiaries'],
  [/^\/me\/profile$/, 'me_profile'],
  [/^\/legal\/[^/]+$/, 'legal'],
  [/^\/notifications$/, 'notifications'],
  [/^\/cart$/, 'cart'],
  [/^\/partner\/scan$/, 'partner_scan'],
]

export function routeTitleKey(pathname: string): string | null {
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  for (const [pattern, key] of ROUTE_TITLE_RULES) {
    if (pattern.test(normalized)) {
      return key
    }
  }
  return null
}

/** Inventory of title keys for the T7.134 guard (parity with `ui.page_title.labels`). */
export function routeTitleInventoryKeys(): string[] {
  return [...new Set(ROUTE_TITLE_RULES.map(([, key]) => key))]
}

